// extracted by mini-css-extract-plugin
export var attachmentContainer = "_nl-0";
export var fileList = "_nl-2";
export var removeFileButton = "_nl-1";